import { breakpoints } from "@gigpro/ui/utils/useBreakpoint";

export type GigView = "list" | "calendar";

export const resolveGigView = ({
  view,
  isDesktop,
  defaultView,
}: {
  view: GigView | undefined;
  isDesktop: boolean;
  defaultView: GigView;
}): GigView => (isDesktop ? (view ?? defaultView) : "list");

export const isDesktopViewport = () => globalThis.matchMedia(`(min-width: ${breakpoints.md}px)`).matches;
